module.exports = __webpack_public_path__ + "static/assets/dd98971c2c185caf86144b6b5234d0fa.svg";